<template>
  <div>
    <admin-contractors-search-filters></admin-contractors-search-filters>
    <admin-contractors-search-results></admin-contractors-search-results>
  </div>
</template>

<script>
  import AdminContractorsSearchFilters from './ContractorsSearchFilter'
  import AdminContractorsSearchResults from './ContractorsSearchResults'

  export default {
    components: {
      AdminContractorsSearchFilters,
      AdminContractorsSearchResults
    }
  }
</script>

<style scoped>

</style>
